import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NGXLogger } from "ngx-logger";
import { getExMessage } from "../../map/map-utils";

@Component({
    selector: "edit-map-image",
    providers: [],
    templateUrl: "./edit-map-image.component.html",
    styleUrls: ["./edit-map-image.component.css"]
})
export class EditMapImageComponent implements OnInit {
    @Input() data: any;
    @ViewChild("mapImageElement", { static: false }) mapImageElement: ElementRef<HTMLImageElement>;
    @ViewChild("editorHost", { static: false }) editorHost: ElementRef<HTMLElement>;

    public loading = false;
    public isEditorOpen = false;
    public mapImgUrl: any = null;
    private mapImgUrlRaw = "";
    private editedMapImgUrl = "";

    constructor(
        @Inject(NgbActiveModal) private activeModal: NgbActiveModal,
        @Inject(NGXLogger) private $log: NGXLogger,
        @Inject(DomSanitizer) private sanitizer: DomSanitizer
    ) {
        //
    }

    public ngOnInit(): void {
        if (this.data && this.data.mapImgUrl) {
            this.mapImgUrlRaw = this.data.mapImgUrl;
            this.mapImgUrl = this.sanitizer.bypassSecurityTrustUrl(this.mapImgUrlRaw) as any;
        } else {
            this.$log.warn("map image url is missing");
            this.activeModal.close(false);
        }
    }

    public async openEditor(): Promise<void> {
        if (!this.mapImageElement || !this.mapImageElement.nativeElement) {
            return;
        }
        if (this.isEditorOpen) {
            return;
        }

        this.loading = true;
        try {
            try {
                await this.mapImageElement.nativeElement.decode();
            } catch (reason) {
                // decode may fail for some browsers/data URLs; continue and let markerjs handle it
            }
            const markerjs2 = await import("markerjs2");
            const markerArea = new markerjs2.MarkerArea(this.mapImageElement.nativeElement);
            const modalBody = this.editorHost?.nativeElement;
            const modalRoot = this.mapImageElement.nativeElement.closest(".modal-content") as HTMLElement;
            if (modalBody) {
                markerArea.targetRoot = modalBody;
            } else if (modalRoot) {
                markerArea.targetRoot = modalRoot;
            }
            if ("uiStyleSettings" in markerArea) {
                (markerArea as any).uiStyleSettings = {
                    ...(markerArea as any).uiStyleSettings,
                    zIndex: 2000,
                };
            }
            
            this.isEditorOpen = true;
            markerArea.addEventListener("render", (event: any) => {
                if (event && event.dataUrl) {
                    this.editedMapImgUrl = event.dataUrl;
                    this.mapImgUrl = this.sanitizer.bypassSecurityTrustUrl(event.dataUrl) as any;
                }
                this.isEditorOpen = false;
            });
            markerArea.addEventListener("close", () => {
                this.isEditorOpen = false;
            });
            markerArea.show();
        } catch (reason) {
            this.$log.error("error opening image editor", getExMessage(reason));
            this.isEditorOpen = false;
        } finally {
            this.loading = false;
        }
    }

    public save(): void {
        this.activeModal.close({ mapImgUrl: this.editedMapImgUrl || this.mapImgUrlRaw });
    }

    public cancel(): void {
        this.activeModal.close(false);
    }
}
